/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

export function groupBy(array: Array<any>, fun: Function | string) {
  return array.reduce((aggregate, element) => {
    const value = typeof fun === 'string' ? element[fun] : fun(element);
    if (aggregate.hasOwnProperty(value)) {
      aggregate[value].push(element);
    } else {
      aggregate[value] = [element];
    }
    return aggregate;
  }, {});
}

export function flatten(array: Array<any>) {
  return [].concat.apply([], array);
}

/**
 * Enums utilities
 */
export class Arrays {
}

Object.defineProperty(Array.prototype, 'toObject', {
  enumerable: false,
  writable: true,
  value: function () {
    const obj = {};
    this.forEach((item, index) => {
      obj[index.toString()] = item;
    });
    return obj;
  }
});

Object.defineProperty(Array.prototype, 'last', {
  enumerable: false,
  value: function () {
    return this[this.length - 1];
  }
});
